export default __webpack_public_path__ + "static/media/cleaning-kindle.18d1d468.jpeg";